import { useState } from 'react';
import { IconButton, Spinner } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import { SFLinkIcon } from '@assets/icons';
import { getUploadLink, downloadFileFromBatch } from '@util/helpers';

export default function UploadLink({ upload, cards, type }) {
  const [isLoading, setIsLoading] = useState(false);
  const link = getUploadLink(upload, cards, type);

  if (isLoading) {
    return (
      <Spinner
        size='sm'
        speed='0.8s'
        color='brandPrimary.primary'
        mr={1}
        data-testid='loading-spinner'
      />
    );
  }

  return (
    <IconButton
      icon={<SFLinkIcon />}
      color='brandPrimary.primary'
      bgColor='white'
      _hover={{
        bgColor: 'brandPrimary.containerLow',
        textDecor: 'none'
      }}
      {...(type === 'Meeting'
        ? { as: Link, to: link }
        : {
            onClick: () => {
              downloadFileFromBatch(upload, setIsLoading);
            }
          })}
    />
  );
}
